class Menu {
  constructor() {
    // this.burger = document.querySelector('#burger');
    this.burger = document.querySelectorAll(".burger");
    this.popupMenu = document.querySelector("#popup-menu");
    this.closePopupMenuButton = document.querySelector(
      "#close-popup-menu-button"
    );
    this.topBar = document.querySelector("#top-bar");
    this.logoO = document.querySelector(".logo-o");
    this.topWhite = document.querySelector("#top-white");
    this.topBlack = document.querySelector("#top-black");
    this.events();
  }

  events() {
    this.burgerClicked();
    this.closePopupMenuButtonClicked();
    this.positionToBarBasedOnLoggedInStatus();
    this.displayBlackOrWhiteMenu();
  }

  displayBlackOrWhiteMenu() {
    // Home
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/la-marque/" ||
      window.location.pathname === "/contact/" ||
      window.location.pathname === "/mon-compte/" ||
      window.location.pathname.includes("commander") ||
      window.location.pathname.includes("mon-compte") ||
      window.location.pathname.includes("retour-produits")
    ) {
      if (this.topBlack) {
        this.topBlack.classList.add("hidden");
      }
      if (this.topWhite) {
        this.topWhite.classList.remove("hidden");
      }
    } else {
      if (this.topBlack) {
        this.topBlack.classList.remove("hidden");
      }
    }
  }

  burgerClicked() {
    if (this.burger && this.popupMenu) {
      this.burger.forEach((burger) => {
        burger.addEventListener("click", (e) => {
          e.preventDefault();
          this.popupMenu.classList.remove("hidden");
          this.popupMenu.classList.add("flex");
        });
      });
    }
  }

  closePopupMenuButtonClicked() {
    if (this.closePopupMenuButton) {
      this.closePopupMenuButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.popupMenu.classList.remove("flex");
        this.popupMenu.classList.add("hidden");
      });
    }
  }

  positionToBarBasedOnLoggedInStatus() {
    if (this.topBar) {
      // Position based on the presence of the black admin bar
      // if (document.querySelector("body").classList.contains("logged-in")) {
      //   this.topBar.style.top = "12px";
      // } else {
      //   this.topBar.style.top = "-20px";
      // }
      // Background color based on scroll
      window.onscroll = () => {
        if (window.pageYOffset <= 24) {
          this.topBar.classList.remove("fixed");
          this.topBar.classList.add("absolute");
          this.topBar.style.backgroundColor = "transparent";
          this.logoO.classList.add("hidden");
          // if (document.querySelector("body").classList.contains("logged-in")) {
          //   this.topBar.style.top = "12px";
          // } else {
          //   this.topBar.style.top = "-20px";
          // }
          // Handle black and white
          if (
            window.location.pathname === "/" ||
            window.location.pathname === "/la-marque/" ||
            window.location.pathname === "/contact/" ||
            window.location.pathname === "/mon-compte/" ||
            window.location.pathname.includes("commander") ||
            window.location.pathname.includes("mon-compte") ||
            window.location.pathname.includes("retour-produits")
          ) {
            if (this.topBlack) {
              this.topBlack.classList.add("hidden");
            }
            if (this.topWhite) {
              this.topWhite.classList.remove("hidden");
            }
          }
        } else {
           if (!document.querySelector("body").classList.contains("logged-in")) {
             this.topBar.style.top = "0px";
           } else {
             this.topBar.style.top = "0px";
            //  this.topBar.style.top = "32px";
           }
           this.topBar.style.top = "0px";
          this.topBar.style.marginTop = "0px";
          this.topBar.classList.add("fixed");
          this.topBar.classList.remove("absolute");
          this.topBar.style.backgroundColor = "#fff";
          this.logoO.classList.remove("hidden");
          // Handle black and white
          if (
            window.location.pathname === "/" ||
            window.location.pathname === "/la-marque/" ||
            window.location.pathname === "/contact/" ||
            window.location.pathname === "/mon-compte/" ||
            window.location.pathname.includes("commander") ||
            window.location.pathname.includes("mon-compte") ||
            window.location.pathname.includes("retour-produits")
          ) {
            if (this.topWhite) {
              this.topWhite.classList.add("hidden");
            }
            if (this.topBlack) {
              this.topBlack.classList.remove("hidden");
            }
          }
        }
      };
    }
  }
}

export default Menu;
